module.exports = __webpack_public_path__ + "img/watching-tv-pizza.8c9292bd.png";